var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "error-window",
    style: {
      backgroundImage: 'url(' + _vm.bgart + '), none'
    }
  }, [_c('div', {
    staticClass: "error-window-text"
  }, [_c('h3', [_vm._v("\n      Oops! Something"), _c('br'), _vm._v("went wrong"), !_vm.hideTellTeacher ? _c('span', [_vm._v(", please tell your teacher")]) : _vm._e(), _vm._v(".\n    ")]), _c('button', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.relogin($event);
      }
    }
  }, [_vm._v("Reload")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }